export default {
  props: {
    data: {
      type: Object,
      default: () => ({
        componentBaseClassName: null,
        componentClassName: null,
      }),
    },
    regions: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      regionsHtml: {},
    };
  },

  mounted() {
    this.setRegionsHtml();
  },

  methods: {
    setRegionsHtml() {
      const regionsHtml = {};
      this.regions?.forEach((region) => {
        region?.components?.forEach(({ custom: { htmlRendered } }) => {
          if (!htmlRendered) return;
          regionsHtml[region.id] = htmlRendered;
        });
      });
      this.regionsHtml = regionsHtml;
    },
  },
};
